import { formatToTwoDecimalPlacesRoundingUp } from '../../../util/PriceUtil';
const priceIncluded = (translate, name, packet, group) => {
    if (!group || !name || !packet) {
        return {
            price: {
                label: translate('tvcomparison.price.included'),
                isIncluded: true,
            },
        };
    }
    const packetName = translate(`tvcomparison.heading.package.${packet}`);
    return {
        price: {
            label: translate(`tvcomparison.price.included.${group}`, {
                name,
                packetName,
            }),
            isIncluded: true,
        },
    };
};
export const priceNotAvailable = (translate, name, packet, group) => {
    if (!group || !name || !packet) {
        return {
            price: {
                label: translate('tvcomparison.price.notIncluded'),
                isIncluded: false,
            },
        };
    }
    const packetName = translate(`tvcomparison.heading.package.${packet}`);
    return {
        price: {
            label: translate(`tvcomparison.price.notIncluded.${group}`, {
                name,
                packetName,
            }),
            isIncluded: false,
        },
    };
};
export const getSinglePriceValue = (price, commonProps) => {
    const { translate, priceLabel } = commonProps;
    return {
        label: priceLabel ? `${translate(priceLabel)}` : undefined,
        price: {
            text: `${price} ${translate(commonProps.pricePerMonthLabel)}`,
        },
    };
};
export const isPricePresent = (price) => !!price || price === 0;
export const formatPriceIfPresent = (price) => {
    if (isPricePresent(price)) {
        return `${formatToTwoDecimalPlacesRoundingUp(price)}`;
    }
    return null;
};
export const getFormattedSinglePrice = (price, isIncluded, commonProps, name, packet, group) => {
    const formattedPrice = formatPriceIfPresent(price);
    if (isIncluded) {
        return priceIncluded(commonProps.translate, name, packet, group);
    }
    else if (formattedPrice) {
        return getSinglePriceValue(formattedPrice, commonProps);
    }
    return priceNotAvailable(commonProps.translate, name, packet, group);
};
export const resolveThemePackagePrices = (prices, commonProps, name, group) => {
    return commonProps.packageNames.map((pkgName) => {
        if (!prices[pkgName]) {
            return commonProps.packagesWithoutPriceExcluded
                ? priceNotAvailable(commonProps.translate, name, pkgName, group)
                : priceIncluded(commonProps.translate, name, pkgName, group);
        }
        const price = prices[pkgName];
        return getFormattedSinglePrice(price, false, commonProps, name, pkgName, group);
    });
};
export const resolvePrices = (prices, includedInPackage, commonProps, isPickableInPackage, name, group) => {
    return commonProps.packageNames.map((pkgName) => {
        if (!(prices === null || prices === void 0 ? void 0 : prices[pkgName]) && !(includedInPackage === null || includedInPackage === void 0 ? void 0 : includedInPackage[pkgName]) && !(isPickableInPackage === null || isPickableInPackage === void 0 ? void 0 : isPickableInPackage[pkgName])) {
            return priceNotAvailable(commonProps.translate, name, pkgName, group);
        }
        const pkgPrice = prices[pkgName];
        const pkgInclusion = includedInPackage[pkgName];
        return getFormattedSinglePrice(pkgPrice, pkgInclusion, commonProps, name, pkgName, group);
    });
};
